import { AxiosResponse } from 'axios'
import { Toastr } from 'components/global/Toastr'
import { Action } from 'types/redux'
import { handleResponseErr } from 'utils/apiHelperUtils'
import * as actions from './actions'
import { GetCandidateReportResponse, GetJobReportResponse } from './types'

type InitialStateType = {
  fetching: boolean
  response: GetJobReportResponse | GetCandidateReportResponse
}

const initialState: InitialStateType = {
  fetching: false,
  response: {
    data: {
      records: [],
    },
    success: false,
  },
}

export default function reducer(
  state = initialState,
  action: Action<AxiosResponse<GetJobReportResponse | GetCandidateReportResponse>>,
): InitialStateType {
  switch (action.type) {
    case actions.GET_JOB_REPORTS_PENDING: {
      return {
        ...state,
        fetching: true,
      }
    }

    case actions.GET_JOB_REPORTS_FULFILLED: {
      return {
        ...state,
        response: action.payload?.data ?? initialState.response,
        fetching: false,
      }
    }

    case actions.GET_JOB_REPORTS_REJECTED: {
      // @ts-expect-error -- it is proper AxiosResponse type
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching: false,
      }
    }
    default:
      return state
  }
}
